/* LFDM — Bouton flottant de scan produit.
   - Le bouton se cale dynamiquement au-dessus des barres fixes du bas d'écran.
   - Caméra et décodeur ne sont chargés qu'après clic sur un CTA de scan.
   - Deux modes : QR code (BarcodeDetector ou jsQR) et code-barres EAN-13, ITF-14,
     GS1-128 et GS1 DataMatrix (BarcodeDetector si l'appareil le sait, sinon
     lfdm-1d.js — seul chemin possible sur iOS).
   - Un GS1-128 de carton porte le GTIN-14 (AI 01) et le n° de lot (AI 10) : le lot
     est mémorisé côté navigateur (sessionStorage + window.LFDM_SCAN) et transmis à
     la page hub en paramètre, sans aucune écriture dans Shopify.
   - Desktop (>= 1000px) : pas de pop-up, ouverture directe de la page « En savoir plus ».
*/
(function () {
  'use strict';

  var fab = document.getElementById('lfdmScanFab');
  var modal = document.getElementById('lfdmScan');
  if (!fab || fab.dataset.scanInit) return;
  fab.dataset.scanInit = '1';

  var CFG = {
    more: fab.getAttribute('data-more') || '',
    hub: fab.getAttribute('data-hub') || '/pages/hub-produit',
    lib: fab.getAttribute('data-lib') || '',
    lib1d: fab.getAttribute('data-lib-1d') || ''
  };
  var deskQ = window.matchMedia('(min-width:1000px)');

  /* ==========================================================
     1. Décalage dynamique : les barres fixes du bas font office
        de « bas d'écran ». Valeur publiée en --lfdm-fixed-bottom.
     ========================================================== */

  var FIXED_SEL = '#lfdmStickyCta,.sticky-cta,.pdp-bar,[data-lfdm-fixed-bottom]';
  var last = -1;
  var ticking = false;

  function vh() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0;
  }

  function occupied() {
    var H = vh();
    if (!H) return 0;
    var max = 0;
    var els = document.querySelectorAll(FIXED_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === fab || (modal && modal.contains(el))) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (parseFloat(cs.opacity || '1') < 0.06) continue;
      var r = el.getBoundingClientRect();
      if (!r.height) continue;
      if (r.bottom < H - 2) continue;   /* pas ancrée en bas */
      if (r.top > H - 2) continue;      /* sortie de l'écran (translation) */
      var h = H - r.top;
      if (h > H * 0.5) continue;        /* garde-fou : ce n'est pas une barre */
      if (h > max) max = h;
    }
    return Math.round(max);
  }

  function locked() {
    return document.body.style.overflow === 'hidden' ||
           document.documentElement.style.overflow === 'hidden';
  }

  function apply() {
    ticking = false;
    var v = occupied();
    if (v !== last) {
      last = v;
      document.documentElement.style.setProperty('--lfdm-fixed-bottom', v + 'px');
    }
    fab.classList.toggle('is-hidden', locked());
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  var ro = window.ResizeObserver ? new window.ResizeObserver(schedule) : null;
  var attrMo = window.MutationObserver ? new window.MutationObserver(schedule) : null;

  function watch() {
    var els = document.querySelectorAll(FIXED_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === fab || el.dataset.lfdmScanWatch) continue;
      el.dataset.lfdmScanWatch = '1';
      if (ro) ro.observe(el);
      if (attrMo) attrMo.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      el.addEventListener('transitionend', schedule);
    }
  }

  function refresh() { watch(); schedule(); }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('orientationchange', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }
  if (window.MutationObserver) {
    new window.MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
    new window.MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    new window.MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  }
  refresh();

  /* ==========================================================
     2. GTIN : extraction, normalisation, clé de contrôle
        et niveau de conditionnement (unité / lot / carton)
     ========================================================== */

  function norm(v) {
    if (!v) return '';
    v = String(v).replace(/[^0-9]/g, '');
    if (v.length < 8 || v.length > 14) return '';
    while (v.length < 14) { v = '0' + v; }
    return v;
  }

  /* Clé de contrôle GS1 : pondération 3/1 en partant de la droite du corps.
     key('370182580008') === '6', clé de l'EAN-13 3701825800086. */
  function key(body) {
    var s = 0;
    for (var i = 0; i < body.length; i++) {
      s += (+body.charAt(i)) * (((body.length - 1 - i) % 2 === 0) ? 3 : 1);
    }
    return String((10 - (s % 10)) % 10);
  }

  function keyOk(g) {
    return g.length === 14 && key(g.slice(0, 13)) === g.charAt(13);
  }

  /* Chiffre indicateur (1er chiffre du GTIN-14), règle La Fabrique des Minis :
       0 -> produit à l'unité (EAN-13 complété d'un zéro de tête)
       1 -> lot
       3 -> carton
     Tout autre indicateur est traité comme un conditionnement générique. */
  var PACK = { '0': '', '1': 'lot', '3': 'carton' };

  function packOf(g) {
    var p = PACK[g.charAt(0)];
    return (p === undefined) ? 'conditionnement' : p;
  }

  /* Ramène un GTIN-14 de lot ou de carton sur le GTIN-14 du produit à l'unité :
     on retire le chiffre indicateur, on garde les 12 chiffres de base et on
     recalcule la clé. 13701825800083 (lot) -> 03701825800086 (unité). */
  function toUnit(g) {
    if (g.charAt(0) === '0') return g;
    var base = g.slice(1, 13);
    return '0' + base + key(base);
  }

  /* ----- Chaînes d'éléments GS1 (GS1-128, GS1 DataMatrix) -----
     Longueur des données pour les AI à longueur fixe. Les AI 31xx à 36xx font
     4 caractères + 6 chiffres, les AI 41x font 3 caractères + 13 chiffres.
     Tout AI absent de cette table est à longueur variable : ses données courent
     jusqu'au séparateur FNC1 (GS, U+001D) ou jusqu'à la fin de la chaîne. */
  var AI_FIX = {
    '00': 18, '01': 14, '02': 14, '03': 14, '04': 16,
    '11': 6, '12': 6, '13': 6, '15': 6, '16': 6, '17': 6, '20': 2
  };

  function aiAt(s, i) {
    var two = s.substr(i, 2);
    if (two >= '31' && two <= '36') return { ai: s.substr(i, 4), n: 6 };
    if (two === '41') return { ai: s.substr(i, 3), n: 13 };
    return { ai: two, n: AI_FIX[two] || -1 };
  }

  function keep(out, ai, val) {
    val = String(val).replace(/\u001d/g, '').trim();
    if (ai === '01' || ai === '02') { if (!out.gtin) out.gtin = norm(val); }
    else if (ai === '10') { if (!out.lot) out.lot = val.slice(0, 20); }
  }

  /* Rend { gtin, lot }. Une chaîne qui n'est pas une suite d'AI cohérente
     ressort avec gtin vide : extract() prend alors le relais. */
  function parseGs1(raw) {
    var out = { gtin: '', lot: '' };
    var s = String(raw == null ? '' : raw).replace(/^\](?:C1|Q3|d2|e0)/, '');
    var m;

    if (s.indexOf('(') > -1) {
      var re = /\((\d{2,4})\)([^(]*)/g;
      while ((m = re.exec(s))) { keep(out, m[1], m[2]); }
      return out;
    }

    if (!/^\d/.test(s)) return out;
    var i = 0;
    var guard = 0;
    while (i < s.length && guard++ < 30) {
      var sp = aiAt(s, i);
      var start = i + sp.ai.length;
      var end;
      if (sp.n > 0) { end = start + sp.n; }
      else {
        end = s.indexOf('\u001d', start);
        if (end < 0) end = s.length;
      }
      if (end > s.length || end <= start) break;
      keep(out, sp.ai, s.slice(start, end));
      i = end;
      while (s.charAt(i) === '\u001d') { i++; }
    }
    return out;
  }

  /* Lot porté par un GS1 Digital Link : .../01/0370.../10/151776 ou ?10=151776 */
  function lotFromUrl(txt) {
    var m = txt.match(/\/10\/([^/?#]+)/);
    var v = '';
    if (m) { try { v = decodeURIComponent(m[1]); } catch (e) { v = m[1]; } }
    if (!v) {
      try { v = new URL(txt).searchParams.get('10') || ''; } catch (e) { v = ''; }
    }
    return String(v || '').slice(0, 20);
  }

  /* Mémoire du scan, côté navigateur uniquement : rien n'est écrit dans Shopify.
     - window.LFDM_SCAN : lecture immédiate par un script de page ;
     - sessionStorage 'lfdm.scan' : survit à la navigation dans l'onglet, ce qui
       permet de pré-remplir un champ « n° de lot » d'un formulaire (HubSpot, SAV)
       ouvert après le scan. L'onglet fermé, la donnée disparaît. */
  var CACHE_KEY = 'lfdm.scan';

  function remember(gtin, unit, lot) {
    var d = { gtin: gtin, unit: unit, lot: lot || '', pack: packOf(gtin), ts: Date.now() };
    window.LFDM_SCAN = d;
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(d)); } catch (e) {}
    return d;
  }

  function extract(raw) {
    if (!raw) return '';
    var txt = String(raw).trim();
    var m;

    /* GS1 Digital Link : .../01/09506000134352/21/xxx */
    m = txt.match(/(?:^|\/)01\/(\d{8,14})(?:\/|\?|$)/);
    if (m) return norm(m[1]);

    /* URL avec paramètre */
    if (/^https?:\/\//i.test(txt)) {
      try {
        var u = new URL(txt);
        var q = u.searchParams;
        var p = q.get('gtin') || q.get('01') || q.get('ean') || q.get('code') || '';
        if (norm(p)) return norm(p);
        var seg = u.pathname.split('/').filter(Boolean).pop() || '';
        if (/^\d{8,14}$/.test(seg)) return norm(seg);
      } catch (e) { /* URL invalide : on continue */ }
    }

    /* Chaîne d'éléments GS1 : AI 01 suivi de 14 chiffres, séparateur FNC1 éventuel */
    m = txt.replace(/[()]/g, '').match(/(?:^|[^0-9])01(\d{14})/);
    if (m) return norm(m[1]);

    /* Code brut */
    if (/^\d{8,14}$/.test(txt)) return norm(txt);

    return '';
  }

  /* Le QR code GS1 porte une URL : on l'ouvre telle quelle, sans la reconstruire.
     Deux verrous avant toute redirection :
       1. l'hôte doit être un domaine GS1 (id.gs1.org, gs1.fr…) ;
       2. le GTIN doit porter la clé entreprise La Fabrique des Minis.
     Tout le reste est refusé. Un code brut, un code-barres lu ou la saisie
     manuelle sont convertis en GTIN-14 — un EAN-13 est complété par un zéro de
     tête —, contrôlés (clé entreprise puis clé de contrôle), ramenés sur le
     produit à l'unité, puis envoyés sur la page hub. */

  var GS1_HOST = /(^|\.)gs1\.[a-z]{2,}$/i;  /* id.gs1.org, gs1.fr, www.gs1.fr… */
  var GS1_PREFIX = '37018258';               /* clé entreprise La Fabrique des Minis */

  function isLfdm(gtin14) {
    return !!gtin14 && gtin14.length === 14 && gtin14.slice(1, 9) === GS1_PREFIX;
  }

  function asUrl(raw) {
    var txt = String(raw == null ? '' : raw).trim();
    if (!txt) return '';
    if (/^https?:\/\//i.test(txt)) return txt;
    if (/^\/\//.test(txt)) return window.location.protocol + txt;
    if (/^[a-z0-9-]+(\.[a-z0-9-]+)+\//i.test(txt)) return 'https://' + txt;
    return ''; /* tout autre schéma (javascript:, data:, tel:…) est ignoré */
  }

  function handle(raw) {
    var url = asUrl(raw);

    if (url) {
      var host = '';
      try { host = new URL(url).hostname.toLowerCase(); } catch (e) { host = ''; }
      if (!GS1_HOST.test(host)) { fail('etranger'); return true; }
      var gu = extract(url);
      if (!isLfdm(gu)) { fail('etranger'); return true; }
      remember(gu, toUnit(gu), lotFromUrl(url));
      stopCam();
      window.location.href = url;
      return true;
    }

    var el = parseGs1(raw);
    if (el.gtin) { goGtin(el.gtin, el.lot); return true; }

    var g = extract(raw);
    if (g) { goGtin(g, ''); return true; }
    return false;
  }

  function goGtin(gtin, lot) {
    if (!isLfdm(gtin)) return fail('etranger');
    if (!keyOk(gtin)) return fail('invalide');

    var pack = packOf(gtin);
    var unit = toUnit(gtin);
    var mem = remember(gtin, unit, lot);

    var idx = document.getElementById('lfdm-hub-index');
    if (idx) {
      var list = [];
      try { list = JSON.parse(idx.textContent) || []; } catch (e) { list = []; }
      if (list.length) {
        var hit = false;
        for (var i = 0; i < list.length; i++) { if (norm(list[i].g) === unit) { hit = true; break; } }
        if (!hit) return fail('inconnu');
      }
    }
    stopCam();
    var url = CFG.hub + (CFG.hub.indexOf('?') > -1 ? '&' : '?') + 'gtin=' + encodeURIComponent(unit);
    if (pack) { url += '&pack=' + encodeURIComponent(pack); }
    if (mem.lot) { url += '&lot=' + encodeURIComponent(mem.lot); }
    window.location.href = url;
  }

  /* ==========================================================
     3. Pop-up : ouverture, fermeture, piège à focus
     ========================================================== */

  var card = modal ? modal.querySelector('.modal-card') : null;
  var paneIntro = document.getElementById('lfdmScanIntro');
  var paneLive = document.getElementById('lfdmScanLive');
  var paneErr = document.getElementById('lfdmScanErr');
  var video = document.getElementById('lfdmScanVideo');
  var stage = document.getElementById('lfdmScanStage');
  var hint = document.getElementById('lfdmScanHint');
  var errText = document.getElementById('lfdmScanErrText');
  var manual = document.getElementById('lfdmScanManual');
  var manualIn = document.getElementById('lfdmScanGtin');
  var manualMsg = document.getElementById('lfdmScanMsg');
  var isOpen = false;
  var prevFocus = null;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  var btnSubmit = document.getElementById('lfdmScanSubmit');
  var btnStart = document.getElementById('lfdmScanStart');
  var btnStart1d = document.getElementById('lfdmScanStartEan');
  var btnMore = document.getElementById('lfdmScanMore');
  var btnStop = document.getElementById('lfdmScanStop');
  var linkManual = document.getElementById('lfdmScanManualLink');

  function show(el, on) { if (el) el.hidden = !on; }

  function pane(name) {
    if (paneIntro) paneIntro.hidden = name !== 'intro';
    if (paneLive) paneLive.hidden = name !== 'live';
    if (paneErr) paneErr.hidden = name !== 'error';

    show(btnSubmit, name === 'error');
    show(btnStart, name !== 'live');
    show(btnStart1d, name !== 'live');
    show(btnMore, name !== 'live');
    show(btnStop, name === 'live');
    show(linkManual, name !== 'error');

    if (btnStart) {
      btnStart.classList.toggle('btn-primary', name !== 'error');
      btnStart.classList.toggle('btn-ghost', name === 'error');
    }
  }

  function focusables() {
    if (!card) return [];
    var out = [];
    var els = card.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.offsetParent === null && el.getClientRects().length === 0) continue;
      out.push(el);
    }
    return out;
  }

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    else if (card && !card.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!modal || isOpen) return;
    isOpen = true;
    prevFocus = document.activeElement;
    pane('intro');
    if (manualMsg) manualMsg.textContent = '';
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey, true);
    var f = focusables();
    if (f.length) f[0].focus();
    schedule();
  }

  function close() {
    if (!modal || !isOpen) return;
    isOpen = false;
    stopCam();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey, true);
    if (prevFocus && prevFocus.focus) { try { prevFocus.focus(); } catch (e) {} }
    schedule();
  }

  /* ==========================================================
     4. Caméra et décodage — chargés uniquement après clic
     ========================================================== */

  var stream = null;
  var loopId = 0;
  var timerId = 0;
  var detector = null;
  var canvas = null;
  var ctx = null;
  var pass = 0;
  var mode = 'qr';   /* 'qr' ou 'ean' */

  var HINT = {
    qr: 'Placez le QR code du produit dans le cadre.',
    ean: 'Placez le code-barres dans le cadre, à l’horizontale et bien à plat.'
  };

  var MSG = {
    refus: 'Accès à la caméra refusé. Autorisez la caméra dans les réglages de votre navigateur, ou saisissez le code sous le code-barres.',
    absent: 'Aucune caméra utilisable sur cet appareil. Saisissez le code situé sous le code-barres du produit.',
    illisible: 'Code non reconnu. Approchez l’appareil, stabilisez-le, ou saisissez le code sous le code-barres.',
    illisible1d: 'Code-barres non reconnu. Tenez-le à l’horizontale et bien à plat, évitez les reflets, ou saisissez les chiffres imprimés dessous.',
    inconnu: 'Ce produit n’a pas été identifié dans notre catalogue. Vérifiez le code saisi.',
    etranger: 'Ce code ne correspond pas à un produit La Fabrique des Minis.',
    invalide: 'Ce code est incomplet ou mal recopié. Vérifiez les chiffres imprimés sous le code-barres.',
    autre: 'La caméra n’a pas pu démarrer. Saisissez le code situé sous le code-barres du produit.'
  };

  function fail(kind) {
    if (kind === 'illisible' && mode === 'ean') kind = 'illisible1d';
    stopCam();
    if (errText) errText.textContent = MSG[kind] || MSG.autre;
    pane('error');
    if (manualIn) { try { manualIn.focus(); } catch (e) {} }
  }

  function stopCam() {
    if (timerId) { clearTimeout(timerId); timerId = 0; }
    if (loopId) { clearTimeout(loopId); loopId = 0; }
    if (stream) {
      var t = stream.getTracks ? stream.getTracks() : [];
      for (var i = 0; i < t.length; i++) { try { t[i].stop(); } catch (e) {} }
      stream = null;
    }
    if (video) {
      try { video.pause(); } catch (e) {}
      video.srcObject = null;
    }
  }

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = res;
      s.onerror = function () { rej(new Error('nolib')); };
      document.head.appendChild(s);
    });
  }

  function loadLib() {
    if (mode === 'ean') {
      if (window.LFDM1D) return Promise.resolve();
      if (!CFG.lib1d) return Promise.reject(new Error('nolib'));
      return loadScript(CFG.lib1d);
    }
    if (window.jsQR) return Promise.resolve();
    if (!CFG.lib) return Promise.reject(new Error('nolib'));
    return loadScript(CFG.lib);
  }

  /* BarcodeDetector natif si — et seulement si — il couvre tout le mode demandé.
     En mode code-barres il faut les quatre symbologies imprimées par LFDM :
     EAN-13 (unité), ITF-14 (lot, carton), GS1-128 et GS1 DataMatrix (étiquette
     carton). À défaut on bascule sur lfdm-1d.js, seul chemin possible sur iOS. */
  function needed() {
    return mode === 'ean' ? ['ean_13', 'itf', 'code_128', 'data_matrix'] : ['qr_code'];
  }

  function loadDecoder() {
    detector = null;
    if (!('BarcodeDetector' in window)) return loadLib();
    return window.BarcodeDetector.getSupportedFormats().then(function (f) {
      var want = needed();
      for (var i = 0; i < want.length; i++) {
        if (!f || f.indexOf(want[i]) < 0) return loadLib();
      }
      detector = new window.BarcodeDetector({ formats: want });
      return null;
    })['catch'](loadLib);
  }

  /* Cadre de capture : carré pour le QR, bande large pour le code-barres
     (moins de pixels à analyser, et cela correspond au viseur affiché). */
  function frame() {
    if (!stream || !video || video.readyState < 2) return null;
    var vw = video.videoWidth;
    var vhh = video.videoHeight;
    if (!vw || !vhh) return null;
    var sw, sh, ow, oh;
    if (mode === 'ean') {
      sw = vw;
      sh = Math.round(vw * 0.45);
      if (sh > vhh) { sh = vhh; sw = Math.min(vw, Math.round(vhh / 0.45)); }
      ow = Math.min(640, sw);
      oh = Math.max(64, Math.round(ow * sh / sw));
    } else {
      sw = sh = Math.min(vw, vhh);
      ow = oh = Math.min(480, sw);
    }
    if (!canvas) { canvas = document.createElement('canvas'); ctx = canvas.getContext('2d', { willReadFrequently: true }); }
    canvas.width = ow;
    canvas.height = oh;
    ctx.drawImage(video, (vw - sw) / 2, (vhh - sh) / 2, sw, sh, 0, 0, ow, oh);
    return ctx.getImageData(0, 0, ow, oh);
  }

  /* QR codes blancs ou à faible contraste : les décodeurs attendent des modules
     sombres sur fond clair. On repasse l'image en niveaux de gris, on étire
     l'histogramme (un blanc sur beige redevient franc) et, une passe sur trois,
     on inverse — ce qui rend lisible un code clair sur fond sombre. */
  function boost(img, invert) {
    var p = img.data;
    var n = p.length;
    var lo = 255;
    var hi = 0;
    var i, g;
    for (i = 0; i < n; i += 16) {
      g = (p[i] * 77 + p[i + 1] * 151 + p[i + 2] * 28) >> 8;
      if (g < lo) lo = g;
      if (g > hi) hi = g;
    }
    var span = hi - lo;
    if (span < 12) span = 12;
    var k = 255 / span;
    for (i = 0; i < n; i += 4) {
      g = (p[i] * 77 + p[i + 1] * 151 + p[i + 2] * 28) >> 8;
      g = (g - lo) * k;
      if (g < 0) g = 0; else if (g > 255) g = 255;
      if (invert) g = 255 - g;
      p[i] = g;
      p[i + 1] = g;
      p[i + 2] = g;
    }
    return img;
  }

  /* m : 0 = image brute, 1 = contraste renforcé, 2 = contraste renforcé + inversion */
  function shot(m) {
    var img = frame();
    if (!img) return null;
    if (m) {
      boost(img, m === 2);
      ctx.putImageData(img, 0, 0);
    }
    return img;
  }

  /* lfdm-1d.js travaille sur un plan de luminance, pas sur du RGBA. */
  function grayOf(img) {
    var p = img.data;
    var n = img.width * img.height;
    var g = new Uint8ClampedArray(n);
    for (var i = 0, j = 0; j < n; i += 4, j++) {
      g[j] = (p[i] * 77 + p[i + 1] * 151 + p[i + 2] * 28) >> 8;
    }
    return g;
  }

  /* Code-barres tenu verticalement : on retente sur l'image transposée. */
  function flip(g, w, h) {
    var o = new Uint8ClampedArray(w * h);
    for (var y = 0; y < h; y++) {
      var r = y * w;
      for (var x = 0; x < w; x++) { o[x * h + y] = g[r + x]; }
    }
    return o;
  }

  function read1d() {
    var img = frame();
    if (!img) return '';
    var p = pass;
    if (p % 4 >= 2) { boost(img, true); }   /* une passe sur deux : inversion */
    var g = grayOf(img);
    var w = img.width;
    var h = img.height;
    if (p % 2) { g = flip(g, w, h); var t = w; w = h; h = t; }
    var r = '';
    try { r = window.LFDM1D.decode(g, w, h) || ''; } catch (e) { r = ''; }
    /* Le DataMatrix est insensible à la rotation : inutile de le retenter transposé. */
    if (!r && p % 4 === 0 && window.LFDM1D.decodeDm) {
      try { r = window.LFDM1D.decodeDm(g, w, h) || ''; } catch (e) { r = ''; }
    }
    return r;
  }

  function tick() {
    if (!stream) return;
    var next = function () { loopId = setTimeout(tick, mode === 'ean' ? 180 : 140); };
    var p = pass;
    pass++;

    if (detector) {
      var src = video;
      var m = (mode === 'ean') ? (p % 2 ? 2 : 0) : (p % 3);
      if (m && shot(m)) src = canvas;
      detector.detect(src).then(function (codes) {
        if (!stream) return;
        for (var i = 0; i < codes.length; i++) {
          if (handle(codes[i].rawValue)) return;
        }
        next();
      })['catch'](next);
      return;
    }

    if (mode === 'ean' && window.LFDM1D) {
      var r1 = read1d();
      if (r1 && handle(r1)) return;
      next();
      return;
    }

    if (mode === 'qr' && window.jsQR) {
      var img = shot(p % 3);
      if (img) {
        /* 'attemptBoth' : jsQR tente aussi la lecture inversée (QR clair sur fond sombre). */
        var r = window.jsQR(img.data, img.width, img.height, { inversionAttempts: 'attemptBoth' });
        if (r && r.data && handle(r.data)) return;
      }
      next();
      return;
    }

    fail('illisible');
  }

  function startCam(m) {
    mode = (m === 'ean') ? 'ean' : 'qr';
    if (hint) hint.textContent = HINT[mode];
    if (stage) stage.classList.toggle('is-1d', mode === 'ean');
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return fail('absent');
    pane('live');
    pass = 0;
    navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } }
    }).then(function (s) {
      if (!isOpen) { var t = s.getTracks(); for (var i = 0; i < t.length; i++) { t[i].stop(); } return null; }
      stream = s;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.srcObject = s;
      return video.play()['catch'](function () { return null; });
    }).then(function () {
      if (!stream) return null;
      return loadDecoder();
    }).then(function () {
      if (!stream) return;
      timerId = setTimeout(function () { if (stream) fail('illisible'); }, 30000);
      tick();
    })['catch'](function (e) {
      var n = e && e.name;
      if (n === 'NotAllowedError' || n === 'SecurityError' || n === 'PermissionDeniedError') return fail('refus');
      if (n === 'NotFoundError' || n === 'DevicesNotFoundError' || n === 'OverconstrainedError') return fail('absent');
      if (e && e.message === 'nolib') return fail('illisible');
      fail('autre');
    });
  }

  /* ==========================================================
     5. Branchements
     ========================================================== */

  fab.addEventListener('click', function () {
    if (deskQ.matches && CFG.more) { window.location.href = CFG.more; return; }
    open();
  });

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-scan-cancel]')) { e.preventDefault(); stopCam(); pane('intro'); return; }
      if (e.target.closest('[data-scan-close]')) { e.preventDefault(); close(); return; }
      var start = e.target.closest('[data-scan-start]');
      if (start) { e.preventDefault(); startCam(start.getAttribute('data-scan-start')); return; }
      if (e.target.closest('[data-scan-manual]')) {
        e.preventDefault();
        if (errText) errText.textContent = '';
        pane('error');
        if (manualIn) { try { manualIn.focus(); } catch (err) {} }
      }
    });
  }

  if (manual) {
    manual.addEventListener('submit', function (e) {
      e.preventDefault();
      var g = norm(manualIn ? manualIn.value : '');
      if (!g) {
        if (manualMsg) manualMsg.textContent = 'Saisissez un code de 8 à 14 chiffres.';
        return;
      }
      if (manualMsg) manualMsg.textContent = '';
      goGtin(g, '');
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopCam();
  });
  window.addEventListener('pagehide', stopCam);
})();
